
import {Injectable} from '@angular/core';
import { GoogleTagManagerService } from 'src/app/core/analytics/google-tag-manager.service';
import { EventType } from '../../enums/event-type.enum';
import { EventCategory } from '../../enums/event-category.enum';
import { EventAction } from '../../enums/event-action.enum';
import { GenericEvent } from './model/generic-event.model';

@Injectable({
  providedIn: 'root'
})
export class HomeSearchFiltersAnalyticsHandler {

  constructor(private readonly googleTagManagerService: GoogleTagManagerService) {}

  sendEvent(eventLabel: string): void {
    this.googleTagManagerService.pushTag({
      event: EventType.Event,
      eventCategory: EventCategory.SearchEngine,
      eventAction: EventAction.SearchFilterInteraction,
      eventLabel: `preencheu-${eventLabel}`
    } as GenericEvent);
  }

}
